import request from "@/http";
/**
 * @param {*} data
 * @returns
 */
const sendMessage = (data) => {
    let { user_list, pre_cmd_para_show_desc, isloading = false,} = data;
    console.log(user_list)
    return request.get({
        url: "application_4_lite_mod_weichat_msg",
        data: {
            invoke_method: "batch_weichat_pub_msg",
            pre_cmd_para_id_public_user_list: user_list,
            pre_cmd_para_show_desc: pre_cmd_para_show_desc
        },
        loading: {
            enabled: isloading
        }
    })
}
export default {
    sendMessage
}
